module.exports = __webpack_public_path__ + "img/m-1.a69c2de4.png";